module.exports = __webpack_public_path__ + "static/img/10.72616a73.png";